import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { Box, Alert } from '@mui/material';
import SEOHead from '../components/SEO/SEOHead';
import PageBackground from '../components/layout/PageBackground';
import BoatSelection from '../components/BoatSelection';
import SailSelection from '../components/SailSelection';
import CreateQuote from '../components/CreateQuote';
import SailOptionsContainer from '../components/sail-options/SailOptionsContainer';
import ScrollToTop from '../components/shared/ScrollToTop';
import { getSailTypeName } from '../utils/quoter/sailTypeMapper';
import ErrorBoundary from '../components/quoter/sail-options/components/shared/ErrorBoundary';
import logger from '../utils/logging/logger';
import { VersionProvider } from '../hooks/quoter/VersionContext';
import AuthenticationManager from '../components/auth/AuthenticationManager';
const componentName = 'QuoterPage';

const ValidatedSailOptionRoute: React.FC = () => {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const [, , boatId, sailId, sailArea, quoteId, sailCutId, isFurling] = pathParts;
    const numericSailId = Number(sailId);
    const sailTypeName = getSailTypeName(numericSailId);
    const numericQuoteId = Number(quoteId);
    //const isFurling = isFurling === '1';

    logger.log('LogVerbose', 'ValidatedSailOptionRoute', 'URL path parts:', { pathParts, boatId, sailId, sailArea, quoteId, sailCutId, isFurling });

    // If quote ID is 0 or invalid, show error
    if (!numericQuoteId) {
        return <Alert severity="error">Invalid quote ID. Please go back to sail selection.</Alert>;
    }

    logger.log('LogVerbose', componentName, 'ValidatedSailOptionRoute');

    // Just render the container directly
    return (
        <SailOptionsContainer
            sailTypeName={sailTypeName}
            boatId={Number(boatId)}
            sailId={Number(sailId)}
            sailArea={Number(sailArea)}
            quoteId={numericQuoteId}
            sailCutId={Number(sailCutId) || 0}
            isFurling={Number(isFurling)}
        />
    );
};


const QuoterPage: React.FC = () => {
    const navigate = useNavigate();

    const handleBoatSelect = (boatId: number, boatUrlId?: string) => {
        // Use SEO-friendly URL if available, otherwise fall back to numeric ID
        const identifier = boatUrlId || boatId;
        navigate(`/quoter/sail-selection/${identifier}`);
    };

    return (
        <AuthenticationManager>
            <SEOHead page="quoter" />
            <PageBackground>
                <Box sx={{
                    paddingTop: { xs: '32px', sm: '40px' },  // Reduced from 64px/80px
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    bgcolor: 'transparent'
                }}>
                    <Box sx={{
                        flexGrow: 1,
                        maxWidth: '1200px',
                        margin: '0 auto',
                        width: '100%'
                    }}>
                        <ScrollToTop />
                        <ErrorBoundary>
                            <VersionProvider initialMasterVersion={0}>
                                <Routes>
                                    <Route
                                        path="/"
                                        element={<BoatSelection onSelect={handleBoatSelect} />}
                                    />
                                    <Route
                                        path="/sail-selection/:boatIdentifier"
                                        element={<SailSelection />}
                                    />
                                    <Route
                                        path="/create-quote/:boatId/:sailId/:sailArea/:sailCutId/:isFurling"
                                        element={<CreateQuote />}
                                    />
                                    <Route
                                        path="/sail-options-select/:boatId/:sailId/:sailArea/:quoteId/:sailCutId/:isFurling?"
                                        element={<ValidatedSailOptionRoute />}
                                    />
                                    <Route path="*" element={<Navigate to="/" replace />} />
                                </Routes>
                            </VersionProvider>
                        </ErrorBoundary>
                    </Box>
                </Box>
            </PageBackground>
        </AuthenticationManager>
    );

};

export default QuoterPage;
